import React, { useMemo } from 'react';

import { getIn } from 'formik';
import { FormikValues } from 'formik/dist/types';

import {
  getFormikValue,
  onChangeWithInitReturn,
} from '../../../../utils/forms/formikFunctions';
import AppTextField, {
  IAppTextFieldProps,
} from '../../textfields/app-text-field/AppTextField';

export interface IFormTextField extends IAppTextFieldProps {
  id?: string;
  name: string;
  formik?: FormikValues;
  onChange?: (e: any) => void;
}

const AppFormTextField: React.FC<IFormTextField> = ({
  id,
  name,
  formik,
  onChange,
  ...textFieldProps
}) => {
  const value = useMemo(
    () => getFormikValue(getIn(formik?.values, name)),
    [formik?.values, name],
  );

  return (
    <AppTextField
      id={id || name}
      value={value}
      name={name}
      onChange={onChangeWithInitReturn(
        name,
        formik,
        textFieldProps.type === 'number',
        onChange,
      )}
      onBlur={formik?.handleBlur}
      error={getIn(formik?.touched, name) && !!getIn(formik?.errors, name)}
      helperText={getIn(formik?.touched, name) && getIn(formik?.errors, name)}
      {...textFieldProps}
    />
  );
};

export default AppFormTextField;
